import { observable } from 'mobx'

export default class ResultsStore {
  @observable charts = []

  updateCharts(charts) {
    this.charts = charts
  }
}



// WEBPACK FOOTER //
// ./src/stores/ResultsStore.js